import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 193 201",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M120.2 201H0L72.8 0H193L120.2 201Z\" fill=\"url(#paint0_linear_197_2099)\"></path><path d=\"M152.188 35.0909L130.455 166H106.741L124.638 58.1662H123.871L89.9936 77.7259L93.5732 55.9929L129.624 35.0909H152.188Z\" fill=\"#F0F5FF\"></path><defs><linearGradient id=\"paint0_linear_197_2099\" x1=\"273\" y1=\"-4.51689\" x2=\"-0.734041\" y2=\"200.018\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0.221635\" stop-color=\"#EFEEFF\"></stop><stop offset=\"0.524835\" stop-color=\"#7F74FF\"></stop></linearGradient></defs>", 3)
  ])))
}
export default { render: render }